module.exports = __webpack_public_path__ + "static/media/BigCaslon-Medium.cd2c027c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/BigCaslon-Medium.eot?#iefix
// module id = 87
// module chunks = 0